export default {
  pricing: {
    title: "Pricing",
    hero: {
      title: "One subscription. Total access.",
      subtitle: "Start for free. Unlock the full experience across web and mobile.",
      newsletterTitle: "1 year of Linemate+ for $45",
      newsletterSubtitle: "Your discount code is automatically applied at checkout, so just choose the annual plan and you’re good to go.",
      newsletterPriceLine: "US$44.99 for the entire year",
      newsletterRenewLine: "Renews at US$59.99/year",
    },
    plans: {
      free: {
        features: [
          "Daily trending plays",
          "Team & player hit rates",
          "Game logs & performance history",
        ],
      },
      annual: {
        billingShort: "year",
        billingLong: "annually",
        features: [
          "Includes everything in Free plan +",
          "Every play signal and full analysis",
          "Starting lineups, injury impacts, and weather",
          "Exclusive access to every parlay",
          "Deeper insights on all trending parlays",
          "Advanced search filters",
          "Option to select and change odds view",
        ],
      },
      monthly: {
        billingShort: "month",
        billingLong: "monthly",
        features: [
          "Includes everything in Free plan +",
          "Every play signal and full analysis",
          "Starting lineups, injury impacts, and weather",
          "Exclusive access to every parlay",
          "Deeper insights on all trending parlays",
          "Advanced search filters",
          "Option to select and change odds view",
        ],
      },
    },
    actions: {
      currentPlan: "Your current plan",
      manage: "Manage",
      upgrade: "Upgrade",
    },
    badges: {
      mostPopular: "Most popular",
      annualSavings: "Save up to 60% with the Annual plan",
    },
    operators: {
      prefix: "Fully integrated with",
      highlight: "global operators",
      suffix: "for a frictionless research to bet experience",
    },
    sections: {
      fullPicture: "See the full picture before you bet",
      signals: "Unlock all of the signals for better context",
    },
    testimonials: {
      trusted: "Trusted by<br/>900k sports bettors",
      betslips: "Over more than<br/>1M+ betslips created",
      previous: "Previous testimonials",
      next: "Next testimonials",
      items: [
        {
          title: "Genuinely best designed app I've encountered in a while.",
          description: "Everything is just where it needs to be, the functions of each selection work as intended, very intricately designed app that is mostly very information-heavy, yet so efficient and organized in its approach. As a stats nerd, I give my well done to Linemate for their app design, and the ease of finding lock'n'loads.",
        },
        {
          title: "Best App of All",
          description: "This is 100% the best app for sports betting… after trying it out for a few days i was sold. i highly recommend the paid version as this app so you can get the full version of what it has to offer… you won't be disappointed! download with confidence and enjoy!",
        },
        {
          title: "The best",
          description: "I've tried a lot of stat apps. Linemate is the one I keep coming back to. They offer the most for free, keep adding features without taking anything away, and the Plus plan is well worth the price. Support replied in 5 minutes. They clearly care about being the go-to app. Highly recommended.",
        },
        {
          title: "Pleasantly surprised",
          description: "If you're new and blindly follow props, results will vary, you still need strategy. I downloaded Linemate after my parlays kept missing by small margins, and my first 7-leg player prop parlay hit. For $10/month (with a free first week), it's easily worth it. It won't be perfect, but it does most of the heavy lifting.",
        },
        {
          title: "Great App!",
          description: "No betting app is ever 100%, but this one has delivered the best results for me so far. It's all real stats and data. The free version is solid, and the subscription is even better, you can easily make it back with this app.",
        },
        {
          title: "Great App that Stands Out",
          description: "Great app that really stands out, affordable with strong features for research. Overall, amazing work, keep it up.",
        },
      ],
    },
    comparison: {
      premium: "Annual/Monthly",
      included: "Included",
      notIncluded: "Not included",
    },
    popup: {
      billedAnnually: "Billed annually",
      savePercent: "Save {{percent}}%",
      upgradeForJust: "Upgrade for just {{price}}/{{billingPeriod}}",
      dismiss: "Dismiss",
    },
  },
};
